import React, { useEffect } from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
import { Item } from '../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Box } from '@mui/system'
import { backGroundColor, backGroundColorForStatus, focusElemnt, getStatusBackground, navigation3 } from '../../common/helper'
import AppsIcon from '@mui/icons-material/Apps'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../common/font/Roboto-Medium-normal'
import {
  crdeitDrawCellDetail,
  excelHeaderColumn,
  excelHeaderCreditReport,
  excelHeaderCreditUsageReport,
  lrDetailPdfFooter,
  pdfCreditTransReport,
  pdfCreditUsageReport,
} from './common/AcountingConstants'
import * as id from './common/AcountingId'
import FilterAltIcon from '@mui/icons-material/FilterAlt';

const TableViewCreditUsage = ({ loginData, apiData, fromDate, toDate, company, StateName, city, branch, updateScreen, disableBtn }) => {
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const [tableData, setTableData] = useState([])
  const [reportData, setReportData] = useState([])
  const [searchData, setSearchData] = useState({
    StateName:'',
    CityName:'',
    BranchName:'',
    ParentBranchName:'',
    CreditLimit:'',
    LimitUsage:'',
    LimitUsageInPer:'',
    CargoBalance:'',
    Status:''
  })
  useEffect(() => {
    if(apiData?.length>0){
      let newData = apiData?.map((item) => {
        return {
          ...item,
          ParentBranchName: item.ParentBranchName === '' ? item?.BranchName : item.ParentBranchName
        }
      })
      setTableData(newData)
      setReportData(newData)
    }
  }, [apiData])

  const columnDefs = [
    { headerName: 'SN', field: 'srNo', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'left', width: "10.75%" }, showFilter: false },
    { headerName: 'State Name', field: 'StateName', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'left', width: "12.75%" }, showFilter: true },
    { headerName: 'City Name', field: 'CityName', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'left', width: "10.75%" }, showFilter: true },
    { headerName: 'Branch Name', field: 'BranchName', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'left', width: "10.75%" }, showFilter: true },
    { headerName: 'Parent Branch', field: 'ParentBranchName', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'left', width: "10.75%" }, showFilter: true },
    { headerName: 'Credit Limit	', field: 'CreditLimit', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'left', width: "10.75%" }, showFilter: true },
    { headerName: 'Limit Usages', field: 'LimitUsage', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'left', width: "10.75%" }, showFilter: true },
    { headerName: 'Usages in %', field: 'LimitUsageInPer', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'left', width: "10.75%" }, showFilter: true },
    { headerName: 'Remaining Limit', field: 'CargoBalance', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'center', width: "8.69%" }, showFilter: true },
    { headerName: 'Status', field: 'Status', xlCol: { dataType: 'string', dataFormatter: null, width: 25 }, headerSx: { textAlign: 'left', width: "13.96%" }, showFilter: true },
  ]

  useEffect(() => {
    let fiterData = tableData.filter((val) =>
      (searchData?.StateName === "" || (val?.StateName && val?.StateName?.toLocaleLowerCase().includes(searchData?.StateName?.toLocaleLowerCase()))) &&
      (searchData?.CityName === "" || (val?.CityName && val?.CityName?.toLocaleLowerCase().includes(searchData?.CityName?.toLocaleLowerCase()))) &&
      (searchData?.BranchName === "" || (val?.BranchName && val?.BranchName?.toLocaleLowerCase().includes(searchData?.BranchName?.toLocaleLowerCase()))) &&
      (searchData?.ParentBranchName === "" || (val?.ParentBranchName && val?.ParentBranchName?.toLocaleLowerCase().includes(searchData?.ParentBranchName?.toLocaleLowerCase()))) &&
      (searchData?.CreditLimit === "" || (val?.CreditLimit && val?.CreditLimit?.toLocaleLowerCase().includes(searchData?.CreditLimit?.toLocaleLowerCase()))) &&
      (searchData?.LimitUsage === "" || (val?.LimitUsage && val?.LimitUsage?.toLocaleLowerCase().includes(searchData?.LimitUsage?.toLocaleLowerCase()))) &&
      (searchData?.LimitUsageInPer === "" || (val?.LimitUsageInPer && val?.LimitUsageInPer.toString().includes(searchData?.LimitUsageInPer))) &&
      (searchData?.CargoBalance === "" || (val?.CargoBalance && val?.CargoBalance?.toLocaleLowerCase().includes(searchData?.CargoBalance?.toLocaleLowerCase()))) &&
      (searchData?.Status === "" || (val?.Status && val?.Status?.toLocaleLowerCase().includes(searchData?.Status?.toLocaleLowerCase())))
    );
    setReportData(fiterData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);
  const handleSearchData = (event, field) => {
    let value = event.target.value.toString(); // Convert value to string
    setSearchData({ ...searchData, [field]: value });
  }
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfColumns = pdfCreditUsageReport.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = excelHeaderColumn.map((col) => {
      if (col?.exportHead === 'Party') {
        return { header: 'Branch', dataKey: 'branch', xlCol: col.xlCol }
      } else {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      }
    })
    const HeaderData = [
      {
        company: company,
        state: StateName,
        city: city,
        branch: branch,
      },
    ]
    // bodyData for credit usage report
    const bodyData = reportData?.map((item, index) =>
      item.isTotal
        ? item
        : {
          srNo: index + 1,
          state: item.StateName,
          city: item.CityName,
          branch: item.BranchName,
          ParentBranchName: item.ParentBranchName,
          creditLimit: item.CreditLimit,
          limitUsage: item.LimitUsage,
          usageInPer: item.LimitUsageInPer,
          remainingLimit: item.CargoBalance,
          status: item.Status,
        }
    )
    const doc = new jsPDF({ orientation: 'P', format: [1156, 1636], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Credit Limit Usage Reports.pdf`,
      subject: 'Credit Limit Usage Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: 120,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        // doc.text(
        //   `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
        //   data.settings.margin.left,
        //   150
        // )
        // doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: bodyData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //---------------data of table-----------
      columnStyles: {
        0: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        1: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        2: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        3: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        4: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        5: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        6: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        7: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        8: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        9: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      didParseCell: (data) => {
        crdeitDrawCellDetail(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Credit Limit Usage Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      },
      // showHead: 'never',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Credit Limit Usage Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('creditLimitTransReport').data = pdfUrl
        // document.getElementById('creditLimitTransReport').data = doc.output('datauristring', ' Credit Limit Usage Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('creditLimitTransReport').data = pdfUrl
        // document.getElementById('creditLimitTransReport').data = doc.output('datauristring', ' Credit Limit Usage Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const InsideRowContent = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}
            >
              {index + 1}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.StateName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.CityName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.ParentBranchName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{
                fontSize: '12px',
                background: 'F5FAFE',
                fontWeight: '500',
                textAlign: 'right',
                whiteSpace: 'nowrap',
                //color: typeof item.CreditLimit === 'number' ? 'red' : item.CreditLimit === 'Unlimited' ? 'green' : '#444',
                color: item.CreditLimit === 'Unlimited' ? 'green' : item.CreditLimit === 'No Credit Limit' ? '' : 'red',
              }}
            >
              {item.CreditLimit}
              {/* if (typeof yourVariable === 'string') {
              } else if (typeof yourVariable === 'number') {
          } */}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.LimitUsage}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.LimitUsageInPer}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.CargoBalance}
            </TableCell>
            {/* <TableCell
              className="reportTD"
              colSpan={1}
              style={{
                fontSize: '12px',
                background: 'F5FAFE',
                fontWeight: '500',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                color: item.Status === 'Active' ? '#3C763C' : '#F05924',
              }}
            >
              {item.Status}
            </TableCell> */}
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ fontSize: '12px', color: item.Status === 'Active' ? '#3C763C' : '#F05924', fontWeight: 'bold' }}
              title={item.Status}
            >
              <span
                className="status"
                style={{
                  backgroundColor: backGroundColorForStatus[`${item.Status}`],
                  padding: '5px 10px 5px 10px',
                  borderRadius: '12px',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.Status}
              </span>
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  const InsideRowContentForExcel = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top', fontSize: '16px' }}>
          <>
            <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
              {index + 1}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.StateName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.CityName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.ParentBranchName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.CreditLimit}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.LimitUsage}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.LimitUsageInPer}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.CargoBalance}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.Status}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  return (
    <>
      <Box className="userReport" style={{ display: 'flex', width: '100%', height: '40px', padding: '12px 0px', marginRight: '0px' }}>
        <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
          <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '16px' }}>Report For: Credit Limit Usage Report</h3>
        </Box>
        <Box
          className="userReport-buttons"
          style={{
            display: 'flex',
            width: '50%',
            justifyContent: 'end',
            alignItems: 'center',
            paddingRight: '16px',
          }}
        >
          {showTable ? (
            <>
              <Box onKeyDown={(e) => navigation3(e, 'creditUsagePdfBtn', id.creditUsageSplitButton, () => { })}>
                <ReactHtmlTableToExcel
                  id="creditUsageExcelBtn"
                  //id="test-table-xls-button"
                  className="userWisereporttemExcelBtn"
                  // className="receiveitemExcelBtn"
                  table="table-to-xls1"
                  filename={`Credit Limit Usage Report ${currentDateTime}`}
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </Box>
              <Box>
                <Button
                  id="creditUsagePdfBtn"
                  onKeyDown={(e) =>
                    navigation3(e, 'creditUsagePrintBtn', 'creditUsageExcelBtn', () => {
                      printClick(true)
                    })
                  }
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => printClick(true)}
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  id="creditUsagePrintBtn"
                  onKeyDown={(e) =>
                    navigation3(e, disableBtn ? id.creditUsageSplitButton : id.stateId, 'creditUsagePdfBtn', () => {
                      printClick(false)
                    })
                  }
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => printClick(false)}
                >
                  Print
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box>
                <Button
                  id="backBtn"
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => (setShowTable(true), updateScreen())}
                >
                  Back
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {showTable ? (
        <>
          <Stack
            sx={{ marginLeft: 2, marginRight: 2, height: 440, paddingTop: '10px', marginBottom: '16px' }}
            className="changeScrollColor"
          >
            <TableContainer className='scrollBlue' style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
              {/* ---------------Table For Excel--------------- */}
              <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {/* -------TableHeader--------- */}
                  <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={4}>
                      Report For: Credit Limit Usage Report
                    </TableCell>
                    <TableCell className="reportTD" colSpan={5}>
                      Company Name : _Maven Tech Services Pvt. Ltd.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={12}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeaderCreditUsageReport?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={3} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{company}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{StateName}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{city}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={3} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{branch}</span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={12}></TableCell>
                  </TableRow>
                  <TableRow style={{ verticalAlign: 'top' }}>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>SN</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>State Name</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>City Name</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>Branch Name</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>Parent Branch</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>Credit Limit</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>Limit Usages</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>Usages in %</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>Remaining Limit</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap', backgroundColor: '#e5f3ff' }} colSpan={1}>Status</TableCell>
                  </TableRow>
                </TableHead>
                {reportData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={11}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : reportData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {reportData?.map((item, index) => (
                      <InsideRowContentForExcel item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table" stickyHeader>
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {/* -------TableHeader--------- */}
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: '#bfe1ff',
                        color: '#444',
                        position: 'sticky',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'left',
                        borderBottom: 'none',
                      }}
                      colSpan={15}
                    >
                      Credit Limit Usage Report
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ backgroundColor: '#e5f3ff', verticalAlign: 'top' }}>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>SN</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>State Name</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>City Name</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Branch Name</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Parent Branch</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Credit Limit</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Limit Usages</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Usages in %</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }} colSpan={1}>Remaining Limit</TableCell>
                    <TableCell className="ReportItemHead" style={{ color: '#444', fontSize: '12px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }} colSpan={1}>Status</TableCell>
                  </TableRow>
                  <TableRow sx={{ '& .MuiTableCell-root': { padding: '6px !important', backgroundColor: '#fff' } }}>
                    {columnDefs.map((col, index) => (
                      col.showFilter ? (
                        <TableCell key={`FTH-${index}`}>
                          <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between', zIndex: 3 }}>
                            <input
                              id={`Contains-${index}`}
                              className="field"
                              value={searchData[col.field]}
                              name="cancelSearchInput"
                              style={{ width: '100%' }}
                              placeholder="Contains"
                              onChange={(e) => handleSearchData(e, col.field)}
                            // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? "createBtn" : `Contains-${index - 1}`, index === 11 ? reportData.length > 0 ? `Edit-0` : 'status' : `Contains-${index + 1}`)}
                            />
                            <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                          </div>
                        </TableCell>
                      ) : <TableCell key={`FTH-${index}`}></TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {reportData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={15}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : reportData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {reportData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="creditLimitTransReport"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
              style={{ marginTop: '10px' }}
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}
export default TableViewCreditUsage
